import { Select } from 'antd';
import { t } from 'i18next';
import { memo } from 'react'

export type RssSourceSelectProps = {
    onChange?: Function;
    value?: string
}

export type RssSource = Array<{
    label: string,
    value: string
}>

export const RssSourceSelect = memo(function RssSourceSelect(props: RssSourceSelectProps) {
    const rssSources : RssSource = [
        {
            label: "Tourism Today",
            value: "https://www.tourismtoday.net/rss"
        },
        {
            label: "Turizm Günlüğü",
            value: "https://www.turizmgunlugu.com/rss"
        },
        {
            label: "Turizm Gazetesi",
            value: "https://www.turizmgazetesi.com/rss"
        },
        {
            label: "Turizmin Sesi",
            value: "https://www.turizminsesi.com/rss"
        }
    ];

    return (
        <>
            <Select
                size="middle"
                placeholder={t("tourismNews.chooseSource")}
                onChange={(value: string) => props.onChange ? props.onChange(value) : undefined}
                options={rssSources}
            />
        </>
    )
})